import React from 'react';
import BuyGuideData from '../../BuyGuideData.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

const GuideTemplate = ({header, data, subHeading}) => {
    let dataToDisplay = BuyGuideData
    if (data) {
        dataToDisplay = data
    }
    return (
        <div className="w-full bg-colour min-h-screen">
            <div className="w-full px-4 sm:px-6 md:px-12 mid-lg:px-16 lg:px-24 pt-24 sm:pt-28 md:pt-36">
                <h1 className='tracking-wide font-thin md:font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-2'>
                    {header}
                </h1>
                <p className='tracking-wide text-xs sm:text-sm md:text-base text-gray-600 pb-6 border-b border-gray-200'>
                    {subHeading}
                </p>
            </div>

            <div className='pb-16 sm:pb-20 grid grid-cols-1 lg:grid-cols-6 gap-8 w-full px-4 sm:px-6 md:px-12 mid-lg:px-16 lg:px-24 py-6 md:pt-8'>
                <div className='lg:col-span-4 bg-white rounded-xl p-6 sm:p-8 shadow-sm border border-gray-100'>
                    <img className="w-full rounded-lg mb-8 object-cover" src="https://dt7j04u1665qi.cloudfront.net/tenants-small.webp" srcSet="https://dt7j04u1665qi.cloudfront.net/tenants-small.webp 400w, https://dt7j04u1665qi.cloudfront.net/tenants-medium.webp 800w, https://dt7j04u1665qi.cloudfront.net/tenants-medium.webp 1200w" loading="lazy" alt="Guide Banner" />
                    
                    <div className="space-y-4">
                        {dataToDisplay.data.map((ele, it) => (
                            <div key={it} className='flex items-start gap-4 sm:gap-6 py-4 border-b border-gray-100 last:border-0'>
                                <div className='flex flex-col items-center flex-shrink-0 w-14 sm:w-16'>
                                    <span className='tracking-widest font-bold text-gray-400 text-[10px] sm:text-xs'>STEP</span>
                                    <span className='text-3xl sm:text-4xl font-light text-bluColor'>{it+1}</span>
                                </div>
                                <div className='border-l border-gray-200 self-stretch'></div>
                                <div className='flex-1 pl-1 sm:pl-2'>
                                    <h3 className='font-bold text-sm sm:text-base text-gray-900 pb-2'>{ele.heading}</h3>
                                    <ul className="list-disc pl-4 text-xs sm:text-sm text-gray-600 space-y-1.5">
                                        {typeof(ele.desc) === "string" ? <li>{ele.desc}</li> : ele.desc.map((el, idx) => <li key={idx}>{el}</li>)}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='lg:col-span-2 w-full lg:sticky lg:top-24 bg-white p-6 rounded-xl shadow-md border border-gray-100 h-fit'>
                    <div className='flex flex-col space-y-4'>
                        <h3 className='font-bold text-base sm:text-lg text-gray-900'>Want to invest in Dubai?</h3>
                        <p className='text-xs sm:text-sm text-gray-600 leading-relaxed'>
                            With more than 50 international roadshows and over 10 billion of Sales, Haideries is ranked as the UAE's #1 Off-Plan Real Estate Advisory. Contact Us to know more.
                        </p>
                        <div className="flex flex-col sm:flex-row lg:flex-col gap-3 pt-2">
                            <a
                                href='https://wa.me/+971502607861'
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full bg-green-500 hover:bg-green-600 text-white rounded-lg flex items-center justify-center py-3 px-4 font-semibold text-xs sm:text-sm transition-colors shadow-sm"
                            >
                                <FontAwesomeIcon icon={faWhatsapp} className='mr-2 text-base' /> WhatsApp
                            </a>
                            <a
                                href='tel:+971542999975'
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full bg-black hover:bg-gray-800 text-white rounded-lg flex items-center justify-center py-3 px-4 font-semibold text-xs sm:text-sm transition-colors shadow-sm"
                            >
                                <FontAwesomeIcon icon={faPhone} className='mr-2 text-sm' /> CALL US
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuideTemplate;
